import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { whiteboardsService } from '../api/whiteboards.service';
import { WHITEBOARD_KEYS } from './queryKeys';

/**
 * Metadata and the hydration snapshot of a single whiteboard.
 *
 * @remarks
 * `staleTime: Infinity` on purpose. Everything after the initial load arrives over the hub,
 * so an automatic refetch would hand back an older snapshot and re-hydrate the document on
 * top of live edits. Reconnects re-read the update log instead, which is incremental.
 */
export function useWhiteboard(whiteboardId: string | null) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId) ?? '';

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: WHITEBOARD_KEYS.detail(activeOrganizationId, whiteboardId ?? ''),
    queryFn: ({ signal }) => whiteboardsService.getById(whiteboardId!, signal).then((r) => r.data),
    staleTime: Infinity,
    enabled: !!activeOrganizationId && !!whiteboardId,
  });

  return {
    whiteboard: data ?? null,
    isLoading,
    isError,
    refetch,
  };
}
